import { defineConfig } from '@chakra-ui/react';
import { createAybleSystem } from '@ayble-health/dashboard-components/theme';

/**
 * Shared Ayble tokens live in `@ayble-health/dashboard-components/theme`.
 * This file re-exports them so existing `from '../../theme/chakra'` imports
 * keep working, and layers on careOS-only radii / shadows that are not
 * part of the shared system yet (`radii.card` / `pill`, `shadows.bottomPanel`).
 */
export {
  brand,
  legacyPalettes,
  accents,
  fontTokens,
  fontSizeTokens,
  fontWeightTokens,
  lineHeightTokens,
  breakpointTokens,
  semanticColorTokens,
  aybleThemeConfig,
} from '@ayble-health/dashboard-components/theme';

/**
 * careOS foundational scales. The shared theme otherwise relies on
 * Chakra's defaults here. `md` / `full` radii are intentionally NOT
 * redefined (existing code uses borderRadius="md"/"full"); we add only
 * the careOS values (`card`, `pill`) and the small steps the careOS
 * recipes use (`xs`, `sm` — unused by existing dashboard code, verified
 * before override).
 */
const careOsConfig = defineConfig({
  theme: {
    tokens: {
      radii: {
        xs: { value: '2px' },
        sm: { value: '4px' },
        card: { value: '8px' },
        pill: { value: '100px' },
      },
      shadows: {
        bottomPanel: { value: '0 -4px 16px 8px rgba(0, 0, 0, 0.05)' },
      },
    },
  },
});

export const designSystem = createAybleSystem(careOsConfig);
